import { ProposalReport } from "@/modules/reports/pages/proposal";
import { createFileRoute } from "@tanstack/react-router";
import {
  clientDetailsQueryOptions,
  distributorEmployeeByIdQueryOptions,
  getDistributorBrandingOptions,
  getDistributorProfileOptions,
  getUserOptions,
  proposalQueryOption,
  proposalReportOptions,
} from "creso-core/hooks";

export const Route = createFileRoute(
  "/(auth)/(headless)/reports/clients/$id/proposal/$proposalId"
)({
  component: ProposalReport,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const userPromise = queryClient.fetchQuery(getUserOptions(true));

    const clientPromise = queryClient.fetchQuery(
      clientDetailsQueryOptions(Number(params.id))
    );
    const distributorProfilePromise = queryClient.fetchQuery(
      getDistributorProfileOptions(true)
    );
    const distributorBrandingPromise = queryClient.fetchQuery(
      getDistributorBrandingOptions(true)
    );

    const proposalPromise = queryClient.fetchQuery(
      proposalQueryOption({ proposalId: Number(params.proposalId) })
    );

    const reportDataPromise = queryClient.fetchQuery(
      proposalReportOptions({ proposalId: Number(params.proposalId) })
    );

    const client = await clientPromise;
    const user = await userPromise;
    const metadata =
      user?.metadata && typeof user.metadata === "object"
        ? (user.metadata as Record<string, unknown>)
        : null;
    const rawEmployeeId = metadata?.id ?? null;
    const employeeId =
      user?.user_type === "employee"
        ? typeof rawEmployeeId === "number"
          ? rawEmployeeId
          : typeof rawEmployeeId === "string"
            ? Number(rawEmployeeId)
            : undefined
        : undefined;

    const employeePromise =
      employeeId != null && user?.user_type === "employee"
        ? queryClient.fetchQuery(
            distributorEmployeeByIdQueryOptions(employeeId, { enabled: true })
          )
        : Promise.resolve(null);

    if (!client) {
      throw new Error("Client not found");
    }

    return {
      client,
      proposalId: params.proposalId,
      proposal: await proposalPromise,
      distributorProfile: await distributorProfilePromise,
      distributorBranding: await distributorBrandingPromise,
      employee: await employeePromise,
      reportData: await reportDataPromise,
    };
  },
});
